export const VQProfileKey = 'VQProfileKey'

export const VQEvents = 'CustomEvents'

export const VQMetricsKey = 'VQMetricsKey'

export const VQPaymentProvidersKey = 'VQPaymentProvidersKey'

export const VQCdpProvidersKey = 'VQCdpProvidersKey'

export const VQWhatsappProvidersKey = 'VQWhatsappProvidersKey'
export const VQMessengerKey = 'VQMessengerKey'
export const VQInstagramKey = 'VQInstagramKey'

export const VQCurrentSubscriptionKey = 'Subscription'

export const VQCurrentSubscriptionPlansKey = 'SubscriptionPlans'

export const VQSubscriptionInvoicesKey = 'SubscriptionInvoices'

export const VQSubscriptionCardsKey = 'SubscriptionCards'

export const VQFetchTeamMembersKey = 'FetchTeam'

export const VQDeleteTeamMemberKey = 'DeleteTeamMember'

export const VQUpdateTeamMemberKey = 'UpdateTeamMember'

export const VQPaymentLinksKey = 'PaymentLinks'

export const VQPaymentLinkProductsKey = 'PaymentLinkProducts'

export const VQGetCountriesKey = 'GetCountries'

export const VQGetPaymentEventsKey = 'GetPaymentEvents'

export const VQGetPersonalizationTags = 'GetPersonalizationTags'

export const VQGetCompanyWebhooksKey = 'GetCompanyWebhooks'

export const VQGetSegmentsKey = 'GetSegments'

export const VQGetSegmentCustomersKey = 'GetSegmentCustomers'

export const VQGetCohortAnalyticsKey = 'GetCohortAnalytics'

export const VQGetCustomersKey = 'GetCustomers'

export const VQGetCustomerKey = 'GetCustomer'

export const VQGetInvoicesKey = 'GetInvoices'

export const VQGetInvoiceOverviewKey = 'GetInvoiceOverview'

export const VQGetSMSProviderSenderIDListKey = 'GetSMSProviderSenderIDList'

export const VQAutomationLogQueryKey = 'AutomationLogs'

export const VQVirtualAccounts = 'VirtualAccounts'

export const VQAutomationsKey = 'Automations'

export const VQMessageStats = 'MessageStats'

export const VQCustomMessages = 'CustomMessages'

export const VQCompanyLists = 'CompanyLists'

export const VQCompanyUsers = 'CompanyUsers'

export const VQCompanyPreferenceKey = 'CompanyPreference'

export const VQGetCompanyAPIKey = 'GetCompanyApi'

export const VQGetCompanyAPITestKey = 'GetCompanyTestApiKey'

export const VQGetSavedTemplatesKey = 'GetSavedTemplatesKey'

export const VQGetDefaultTemplatesKey = 'GetDefaultTemplatesKey'

export const VQGetWalletKey = 'GetWallet'
export const VQGetSettingKey = 'GetSetting'
export const VQCustomerDataDeletionKey = 'CustomerDataDeletion'

export const VQGetWalletTransactionsKey = 'GetWalletTransactions'

export const VQGetRolesKey = 'GetRoles'

export const VQGetRoleByIdKey = 'GetRoleById'

export const VQDeleteRoleKey = 'DeleteRole'

export const VQGetPermissionsKey = 'GetPermissions'
